import React from 'react'
import './styles/footer.css'
import facebook_icon from '../assets/facebook_icon.svg'
import instagram_icon from '../assets/instagram_icon.svg'
import youtube_icon from '../assets/youtube_icon.svg'
import {Link} from "react-router-dom";

export default function Footer() {

    const returnEveryLinks = (link, value) => {
        return (
            <Link to={link} className={'open_sans_300'}>
                {value}
            </Link>
        )
    };

    return (
        <footer>
            <div className={'wrapper_content'}>
                <div className={'deluxe_mobili_info_wrapper wrapper_every_block'}>
                    <div className={'wrapper_info_description'}>
                        <span className={'playfair_display_400 logo'}>
                            Vinteriors
                        </span>
                        <span className={'open_sans_300 description'}>
                            Vinteriors presents the best author's design projects, premium furniture and home accessories.
                        </span>
                    </div>
                    <div className={'wrapper_join_to_us_section'}>
                        <span className={'open_sans_400'}>Join us</span>
                        <div className={'wrapper_social_media'}>
                            <a href="https://www.google.com/">
                                <img src={facebook_icon} alt="facebook_icon"/>
                            </a>
                            <a href="https://www.google.com/">
                                <img src={instagram_icon} alt="instagram_icon"/>
                            </a>
                            <a href="https://www.google.com/">
                                <img src={youtube_icon} alt="youtube_icon"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div className={'wrapper_every_block'}>
                    <span className={'open_sans_400 block_title'}>
                        Pages
                    </span>
                    <div className={'wrapper_links'}>
                        {returnEveryLinks("/catalogue/popular_products?", 'Catalog')}
                        {returnEveryLinks("/terms/delivery", 'Conditions')}
                        {returnEveryLinks("/about_company", 'About company')}
                        {returnEveryLinks("/contacts", 'Contacts')}
                    </div>
                </div>
                {/*<div className={'wrapper_every_block'}>*/}
                {/*    <span className={'open_sans_400 block_title'}>*/}
                {/*        Информация*/}
                {/*    </span>*/}
                {/*    <div className={'wrapper_links'}>*/}
                {/*        {returnEveryLinks("https://www.google.com/", 'О нас')}*/}
                {/*        {returnEveryLinks("https://www.google.com/", 'Команда')}*/}
                {/*        {returnEveryLinks("https://www.google.com/", 'Партнеры')}*/}
                {/*        {returnEveryLinks("https://www.google.com/", 'Пресса')}*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className={'wrapper_every_block'}>
                    <span className={'open_sans_400 block_title'}>
                       Important
                    </span>
                    <div className={'wrapper_links'}>
                        {returnEveryLinks("/terms/delivery", 'Shipping Policy')}
                        {returnEveryLinks("/terms/terms_and_conditions", 'Terms and Conditions')}
                        {returnEveryLinks("/terms/privacy_policy", 'Privacy policy')}
                        {returnEveryLinks("/terms/cookies", 'Cookies')}
                        {returnEveryLinks("/terms/for_b2b_clients", 'For B2B Clients')}
                    </div>
                </div>
                <div className={'wrapper_every_block'}>
                    <span className={'open_sans_400 block_title'}>
                       Other services
                    </span>
                    <div className={'wrapper_links'}>
                        <button onClick={() => window.open('https://vesperinteriors.com')} className={'request-design-button'}>ORDER INTERIOR <br/>DESIGN</button>
                    </div>
                </div>
                <div className={'wrapper_every_block mobile_version'}>
                    <span className={'open_sans_400 block_title'}>Join us</span>
                    <div className={'wrapper_social_media'}>
                        <a href="https://www.google.com/">
                            <img src={facebook_icon} alt="facebook_icon"/>
                        </a>
                        <a href="https://www.google.com/">
                            <img src={instagram_icon} alt="instagram_icon"/>
                        </a>
                        <a href="https://www.google.com/">
                            <img src={youtube_icon} alt="youtube_icon"/>
                        </a>
                    </div>
                </div>
                <div className={'wrapper_all_rights_reserved'}>
                    <span className={'roboto_400'}>
                        ©Vinteriors. All rights reserved.
                    </span>
                </div>
            </div>
        </footer>
    )
}
